import Controller from "@ember/controller";
import { task } from "ember-concurrency";
import { service } from "@ember/service";
import destroyRecord from "glesys-controlpanel/utils/destroy-record";
import { saveRecord } from "@warp-drive/legacy/compat/builders";

export default class OrganizationCollaboratorsOverviewController extends Controller {
  @service store;

  get organization() {
    return this.model.organization;
  }

  get collaborators() {
    return this.model.collaborators;
  }

  get sortedCollaborators() {
    return this.collaborators
      .slice()
      .sort((a, b) => a.isInvitePending - b.isInvitePending || a.username.localeCompare(b.username));
  }

  inviteCollaboratorTask = task(async (username) => {
    let organization = this.organization;
    let collaborator = this.store.createRecord("collaborator", {
      organization,
      username,
    });

    return this.store
      .request(saveRecord(collaborator))
      .then(({ content }) => content)
      .catch((error) => {
        collaborator.deleteRecord();
        throw error;
      });
  });

  deleteCollaboratorTask = task(async (collaborator) => {
    return destroyRecord(collaborator).catch((error) => {
      collaborator.rollbackAttributes();
      throw error;
    });
  });
}
